<template>
  <v-container>
    <v-dialog 
      persistent 
      v-model="isOpen" 
      @click:outside="closeDialog" 
      @keydown.esc="closeDialog" 
      max-width="600px" 
      @keydown.ctrl="pegar"
    >
      <v-card>
        <v-card-title class="py-2">
          <span class="headline">Agregar Ticket</span>
          <v-spacer></v-spacer>
          <v-btn fab small text @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="black--text">
          <p class="mb-4">
            Escribe qué necesitas. Antes de enviarlo revisamos que el ticket traiga los datos del caso.
          </p>

          <!-- Datos generales -->
          <v-row>
            <v-col cols="12" :class="destacarAlumno ? 'revision-destacada' : ''">
              <label class="black--text"><b>¿El problema está relacionado a uno o más alumnos?</b></label>
              <div v-if="destacarAlumno" class="orange--text text--darken-3 text-body-2 mt-1">
                Marca SI, busca al alumno y agrégalo a la lista.
              </div>
              <v-radio-group
                v-model="opContieneAlumno"
                row
                hide-details
              >
                <v-radio
                  label="SI"
                  :value="1"
                ></v-radio>
                <v-radio
                  label="NO"
                  :value="2"
                ></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12" v-if="opContieneAlumno == 1">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    :items="alumnos"
                    v-model="alumno"
                    label="Alumno"
                    filled
                    hide-details
                    dense
                    return-object
                    item-text="datos_completos"
                    item-value="id_alumno"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    :items="grupos"
                    v-model="grupo"
                    label="Grupo"
                    filled
                    hide-details
                    dense
                    return-object
                    item-text="grupo"
                    item-value="id_grupo"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                  <v-btn small dark color="primary" @click="saveResultado()" tile class="my-2">
                    <v-icon>mdi-plus</v-icon>
                    Agregar
                  </v-btn>
                </v-col>
              </v-row>
              <v-data-table
                :headers="headersAlumnos"
                :items="alumnos_ticket"
                class="elevation-0 mt-4"
                :mobile-breakpoint="100"
                dense
              >

                <template v-slot:item.actions="{ item }">
                  <v-btn 
                    color="error" 
                    x-small
                    @click="deleteItem2(item)"
                    class="mr-2"
                  >
                    <v-icon small> mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>

            <v-col cols="12" :class="destacarDetalle ? 'revision-destacada' : ''">
              <v-textarea
                filled
                v-model="motivo"
                label="Qué necesitas que hagan"
                :hint="destacarDetalle ? '' : 'Incluye quién, qué y cuándo. Ejemplo: quitar el adeudo de septiembre de Ana López.'"
                :persistent-hint="!destacarDetalle"
                :rows="3"
                auto-grow
              ></v-textarea>
              <div v-if="destacarDetalle" class="orange--text text--darken-3 text-body-2 mt-2">
                {{ avisoCorto }}
              </div>
            </v-col>

            <v-col cols="12">
              <v-file-input small-chips multiple filled v-model="files" accept="image/png, image/jpeg, image/bmp, video/mp4, video/x-m4v, video/*, application/pdf, .pdf"
                placeholder="Imágenes, videos o PDF" prepend-icon="mdi-camera" label="Evidencias" @change="cargarFotos()">
              </v-file-input>
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                filled
                dense
                hide-details
                :items="sucursales"
                v-model="sucursal"
                label="Selecciona una sucursal"
                item-value="id_plantel"
                item-text="plantel"
              >
              </v-autocomplete>
            </v-col>
          </v-row>

        <v-row v-if="vistaPrevias.length">
          <v-col cols="12" md="3" v-for="(img, i) in vistaPrevias" :key="i">
            <v-card class="py-4 shadowCard">
              <EvidenciaMini :src="img.url" :video="!!img.video" :pdf="!!img.pdf" :nombre="img.image_name" />
              <v-btn  color="error"  small  @click="eliminarFoto(img.url)" top right absolute fab >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-sheet
        v-if="revisionPendiente"
        ref="panelRevision"
        class="mx-4 mb-2 pa-4 revision-panel"
      >
        <div class="d-flex align-start">
          <v-icon color="orange darken-2" class="mr-3 mt-1">mdi-alert-circle</v-icon>
          <div class="flex-grow-1">
            <div class="text-subtitle-1 font-weight-bold">El ticket no se envió</div>
            <div class="text-body-2 mt-1">{{ avisoCorto }}</div>
            <div class="mt-3" v-if="revisionPendiente.etiqueta || revisionPendiente.departamento">
              <v-chip
                v-if="revisionPendiente.etiqueta"
                small
                outlined
                color="primary"
                class="mr-2 mb-1"
              >
                {{ revisionPendiente.etiqueta }}
              </v-chip>
              <v-chip
                v-if="revisionPendiente.departamento"
                small
                outlined
                class="mb-1"
              >
                Va para {{ revisionPendiente.departamento }}
              </v-chip>
            </div>
            <div v-if="ejemploUtil" class="mt-3">
              <div class="font-weight-bold">Así puede quedar tu texto</div>
              <div class="revision-ejemplo mt-1">{{ ejemploMostrado }}</div>
              <v-btn small text color="primary" class="mt-2 px-0" @click="usarEjemplo()">
                Usar este texto
              </v-btn>
            </div>
            <div class="mt-3 font-weight-bold">Qué hacer</div>
            <ol class="pl-4 mb-0">
              <li v-for="(paso, i) in pasosRevision" :key="i" class="mb-1">{{ paso }}</li>
            </ol>
          </div>
        </div>
      </v-sheet>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="deep-purple"
          tile
          v-if="requiere_ticket"
          :loading="cargar"
          :disabled="cargar"
          @click="save()"
          dark
          small
          class="mb-2"
        >
          <v-icon small left>mdi-auto-fix</v-icon>
          {{ textoBotonAgregar }}
        </v-btn>
      </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogSoporteTecnico"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card class="shadowCard">
        
        <v-card-title class="text-subtitle-1">
          Asistente de Soporte Técnico
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogSoporteTecnico = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <!-- Iniciar el chat por primera vez -->
        <v-card-text v-if="!estado">
          <div
            v-for="(problema, i) in problemas"
            :key="i"
            class="mb-2"
          >
            <v-chip 
              color="blue"
              outlined
              label
              @click="iniciarChat( problema.id )"
            >
              <v-icon left>
                mdi-wrench
              </v-icon>
              {{ problema.titulo }}
            </v-chip>
          </div>
        </v-card-text>  

        <!-- Cuando ya se seleccionó un problema -->
        <v-card-text v-if="estado" class="mt-6 black--text">

          <!-- Está es la sección de pregunta -->
          <div v-if="estado.tipo === 'pregunta'">
            <p class="text-subtitle-1 font-weight-bold">{{ estado.pregunta }}</p>
            <v-btn
              v-for="respuesta in estado.respuestas"
              :key="respuesta.id"
              class="ma-2"
              color="primary"
              @click="iniciarChat(respuesta.id)"
            >
              {{ respuesta.texto }}
            </v-btn>
          </div>

          <!-- Está es la sección de la solución -->
          <div v-else-if="estado.tipo === 'solucion'">
            <p class="text-subtitle-1 font-weight-bold">
              <v-img src="@/assets/iconos/idea.png" height="24" max-width="24" />
              Solución sugerida:
              <br/>
              <br/>
            </p>

            <p>{{ estado.solucion }}</p>
            <v-chip 
              color="success" 
              class="mt-4"
              outlined
              label 
              @click="reiniciar"
            >
              <v-icon left>
                mdi-refresh
              </v-icon>
              Iniciar de nuevo
            </v-chip>
          </div>

        </v-card-text>
      </v-card>
    </v-dialog>

    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>
  </v-container>
</template>
<script>

  import axios from 'axios';
  import {mapGetters, mapActions} from 'vuex'
  import { Clipboard } from "@capacitor/clipboard";
  
    // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue'
  import EvidenciaMini         from '@/components/tickets/EvidenciaMini.vue'
  import { clasificarArchivoEvidencia } from '@/utils/ticketEvidencias'

  import validarErrores  from '@/mixins/validarErrores'
  export default {

    components:{
      Alerta,
      carga,
      EvidenciaMini,
    },

    mixins: [ validarErrores ],

    props: [
      'isOpen',
      'temas',
      'subtemas'
    ],

    watch: {
      area(){
        if (!this.area || !this.area.puestos) {
          this.puestos = []
          this.puesto = null
          return
        }
        this.puestos = this.area.puestos.filter(function (p) {
          return Number(p.idpuesto) !== 85 && Number(p.idpuesto) !== 108
        })
        for (const i in this.puestos) {
          if (this.puestos[i].idpuesto == 68) {
            this.puestos[i].puesto = 'RH'
          }
        }
        if (this.puestos.length === 1) {
          this.puesto = this.puestos[0]
        } else {
          this.puesto = null
        }
      },

      puesto(){
        if (!this.puesto) {
          this.jefes = []
          this.jefe = null
          return
        }
        this.jefes = this.puesto.jefes

        const esther = this.jefes.find(function (el) { return Number(el.id_usuario) === 568 })
        this.jefe = esther || this.jefes[0]
      },

      alumno( ){
        if( this.alumno ){
          this.getGruposAlumno()
        }
      },

      idsubtemas_tickets( val ){
        if( val ){
          this.infoSubtema = this.subtemas.find( el => el.idsubtemas_tickets == val ) 
          this.requiere_ticket     = this.infoSubtema.requiere_ticket 
          this.panel               = this.infoSubtema.panel 
          this.evidencia_requerida = this.infoSubtema.evidencia_requerida 
        }else{
          this.requiere_ticket     = true 
          this.panel               = null 
          this.evidencia_requerida = null 
          this.infoSubtema         = null
        }

      }

    },

    computed:{
      ...mapGetters('login',['getdatosUsuarioERPERP']),

      textoBotonAgregar () {
        if (this.estaProcesando) return 'Revisando...'
        if (this.revisionPendiente) return 'Volver a intentar'
        return 'Agregar'
      },

      destacarAlumno () {
        return this.revisionPideAlumno && Number(this.opContieneAlumno) !== 1
      },

      destacarDetalle () {
        if (!this.revisionPendiente) return false
        return !this.destacarAlumno
      },

      textoRevision () {
        const rev = this.revisionPendiente
        return String(rev && rev.mensaje ? rev.mensaje : '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
      },

      faltaFecha () {
        return this.textoRevision.indexOf('que dia') !== -1
      },

      faltaHora () {
        return this.textoRevision.indexOf('que hora') !== -1
      },

      faltaPersona () {
        const texto = this.textoRevision
        return texto.indexOf('a quien') !== -1 || texto.indexOf('el nombre') !== -1
      },

      avisoCorto () {
        const partes = []
        if (this.faltaFecha) partes.push('Agrega la fecha. Por ejemplo: el sábado 3 de octubre.')
        if (this.faltaHora) partes.push('Agrega la hora. Por ejemplo: 10:30 am.')
        if (this.faltaPersona) partes.push('Agrega el nombre de la persona.')
        if (partes.length) return partes.join(' ') + ' No borres lo que ya escribiste.'
        const anexa = this.textoRevision.match(/anexa en tu texto ([^.]+)/)
        if (anexa && anexa[1]) return 'Agrega ' + anexa[1].trim() + '. No borres lo que ya escribiste.'
        return 'Agrega aquí el dato que falta. No borres lo que ya escribiste.'
      },

      ejemploMostrado () {
        const rev = this.revisionPendiente
        const base = String(this.motivo || '').replace(/\s+/g, ' ').trim()
        const extra = []
        if (this.faltaFecha) extra.push('Fecha: el sábado 3 de octubre.')
        if (this.faltaHora) extra.push('Hora: 10:30 am.')
        if (this.faltaPersona) extra.push('Persona: escribe el nombre completo.')
        if (base && extra.length) return base + ' ' + extra.join(' ')
        return rev && rev.ejemplo ? rev.ejemplo : ''
      },

      ejemploUtil () {
        if (!this.ejemploMostrado) return false
        const limpio = function (texto) {
          return String(texto || '').replace(/\s+/g, ' ').trim().toLowerCase()
        }
        return limpio(this.ejemploMostrado) !== limpio(this.motivo)
      },

      revisionPideAlumno () {
        const rev = this.revisionPendiente
        if (!rev) return false
        if (this.esAjusteReloj(rev.etiqueta) || this.esBecaEmpleado(rev.etiqueta)) return false
        const texto = String(rev.mensaje || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
        return texto.indexOf('alumno') !== -1 || texto.indexOf('matric') !== -1
      },

      pasosRevision () {
        const rev = this.revisionPendiente
        if (!rev) return []
        if (!rev.etiqueta) {
          return [
            'En el recuadro escribe qué necesitas que hagan.',
            'Di quién, qué y cuándo. Por ejemplo: quitar un adeudo, reparar el clima o corregir una hora del reloj.',
            'Pulsa Volver a intentar.'
          ]
        }
        if (this.revisionPideAlumno && Number(this.opContieneAlumno) !== 1) {
          return [
            'Marca SI en la pregunta de alumnos. Esa sección quedó marcada en naranja.',
            'Busca al alumno, elige su grupo y pulsa Agregar en esa sección.',
            'Pulsa Volver a intentar.'
          ]
        }
        if (this.revisionPideAlumno) {
          return [
            'Si el alumno no está en la tabla, búscalo, elige su grupo y pulsa Agregar en esa sección.',
            'En el recuadro agrega el detalle que falta, sin borrar lo que ya escribiste.',
            'Pulsa Volver a intentar.'
          ]
        }
        if (this.ejemploUtil && this.faltaFecha) {
          return [
            'Pulsa Usar este texto. Ya trae una fecha de ejemplo; cámbiala si es otro día.',
            'No borres lo que ya escribiste.',
            'Pulsa Volver a intentar.'
          ]
        }
        if (this.ejemploUtil) {
          return [
            'Pulsa Usar este texto, o escribe el dato que falta al final de tu mensaje.',
            'No borres lo que ya escribiste.',
            'Pulsa Volver a intentar.'
          ]
        }
        return [
          'El recuadro del problema quedó marcado. Agrega ahí el dato que falta.',
          'No borres lo que ya escribiste.',
          'Pulsa Volver a intentar.'
        ]
      },

      filterSubtemas( ){

        if( this.idtemas_tickets ){

          return this.subtemas.filter( el => el.idtema == this.idtemas_tickets )

        }else{ return [] }

      },

      filterAlumnos( ){
        // Valdiar que este buscando algo 
        if(this.searchAlumno){
          // filtar los alumnos
          return this.alumnos.filter( el => {

            // normalizar los datos completos del alumno
            let datos_completos = el.datos_completos.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"")

            // Normalizar el datos buscado
            const buscar        = this.searchAlumno.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"")

            // Realizar el match
            return datos_completos.match(buscar)
          })
        }else{ return this.alumnos }
      },

      filterAreas( ){

        let data = this.areas

        // if( [334,954,32,31,966,28,568].includes( this.getdatosUsuarioERPERP.iderp ) ){
          // return this.areas
        // }else{
          return this.areas.filter( el => el.departamento != 'DIRECCION GENERAL' )
        // }


      }

    },

    data: () => ({
      respuestaAlerta:false,
      cargar: false,
      estaProcesando: false,
      urgente: 0,
      url:'',

      fotos:[],
      files: [],
      vistaPrevias:[],

      area: null,
      motivo: "",
      motivo_aux: "",
      plantel: null,
      planteles: [
        { id_plantel: 1, plantel: "INBI" },
        { id_plantel: 2, plantel: "FAST ENGLISH" },
      ],

      sucursales:[],
      sucursal: null,

      areas:[],
      area: null,

      puestos:[],
      puesto:null,

      jefes:[],
      jefe: null,

      show_folio: false,

      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      idtemas_tickets: null,
      idsubtemas_tickets: null,
      otro_motivo:null,

      opContieneAlumno: null,

      alumno: null,
      grupo: null,
      grupos:[],
      alumnos: [],
      headersAlumnos:[
        { text: 'matricula', value: "matricula" },
        { text: 'alumno'   , value: "alumno" },
        { text: 'grupo'    , value: "grupo" },
      ],

      searchAlumno:'',
      alumnos_ticket:[],
      infoSubtema: null,
      requiere_ticket: true,
      panel: null,
      evidencia_requerida: '',

      ruta: [],
      estado: null,
      problemas: [],

      dialogSoporteTecnico: false,
      revisionPendiente: null,

    }),

    async created() {
      var url = axios.defaults.baseURL + 'evidencia-tickets/'
      this.initialize( )
      await this.getAreas( )
      await this.getAlumnos( )
      await this.getSoporte( )
    },

    methods: {

      initialize () {
        this.sucursales = []
        this.cargar = true
        this.$http.get("sucursales.all").then(response=>{
          this.sucursales = response.data
          this.cargar     = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getAreas () {
        this.cargar = true
        this.areas = []
        this.$http.get('departamentos.tickets').then(response=>{
          this.areas = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      closeDialog(){
        this.revisionPendiente = null
        this.$emit('close');        
      },

      esAjusteReloj (etiqueta) {
        const texto = String(etiqueta || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
        return texto.indexOf('reloj') !== -1 || texto.indexOf('chequeo') !== -1
      },

      esBecaEmpleado (etiqueta) {
        const texto = String(etiqueta || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
        return texto.indexOf('beca de empleado') !== -1
      },

      usarEjemplo () {
        if (!this.ejemploMostrado) return
        this.motivo = this.ejemploMostrado
      },

      getAlumnos( ) {
        this.cargar = true
        this.alumnos = []
        return this.$http.get('inscripciones.alumnos').then(response=>{
          this.cargar = false
          this.alumnos = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getGruposAlumno ( ){
        this.cargar = true
        this.grupos = []
        return this.$http.get('cambios.grupo.usuario/' + this.alumno.id_alumno).then(response=>{
          this.grupos = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      async save() {

        if( this.estaProcesando ) return

        if(!this.opContieneAlumno){
          return this.validarErrorDirecto('Por favor, llena la primer pregunta')
        }

        if(this.opContieneAlumno == 1 && this.alumnos_ticket.length < 1 ){
          return this.validarErrorDirecto('Por favor, llena los datos del alumno')
        }


        if(!this.vistaPrevias.length){
          return this.validarErrorDirecto('Lo sentimos, pero no puedes subir un ticket sin EVIDENCIA')
        }

        if( !this.motivo || !String(this.motivo).trim() ){
          return this.validarErrorDirecto('Favor de describir el problema')
        }

        if( !this.sucursal ){
          return this.validarErrorDirecto('Favor de seleccionar una sucursal')
        }

        if (this.getdatosUsuarioERPERP.iderp > 0) {

          this.cargar = true
          this.estaProcesando = true
          this.revisionPendiente = null
          let revision = null
          try {
            const respuestaRevision = await this.$http.post('tickets.revisar', {
              motivo: this.motivo,
              alumnos: this.alumnos_ticket
            })
            revision = respuestaRevision.data
          } catch (error) {
            this.estaProcesando = false
            this.cargar = false
            const mensaje = error && error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : 'No se pudo revisar el ticket'
            return this.validarError(mensaje)
          }
          if (!revision || !revision.listo) {
            this.revisionPendiente = {
              mensaje: revision && revision.mensaje
                ? revision.mensaje
                : 'Agrega más información para poder asignar el ticket.',
              etiqueta: revision && revision.etiqueta ? revision.etiqueta : '',
              departamento: revision && revision.departamento ? revision.departamento : '',
              ejemplo: revision && revision.ejemplo ? revision.ejemplo : ''
            }
            this.estaProcesando = false
            this.cargar = false
            this.$nextTick(() => {
              const panel = this.$refs.panelRevision
              const el = panel && panel.$el ? panel.$el : panel
              if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
            })
            return
          }
          this.revisionPendiente = null

          let fotos = []
          if(this.vistaPrevias.length){
            let respuesta = await this.subirFotosServidor( )
            fotos = respuesta.data
          }

          var payload = {
            id_unidad_negocio: 0,
            id_area          : revision.id_area,
            idjefe_area      : revision.idjefe_area,
            motivo           : this.motivo,
            estatus          : 2,
            id_usuario       : this.getdatosUsuarioERPERP.iderp,
            tipousuario      : 0,
            id_suc           : this.sucursal,
            urgente          : 0,
            fotos,
            idtemas_tickets   : null,
            idsubtemas_tickets: null,
            otro_motivo       : null,
            alumnos           : this.alumnos_ticket,
            id_concepto      : revision.id_concepto
          };

          this.$http.post("tickets.add", payload).then((response) => {
            this.folio               = response.data.ticket.id;
            this.idhistorial_ticket  = response.data.historial.id;
            this.otro_motivo         = null
            this.motivo_aux = this.motivo;
            this.show_folio = true;
            this.plantel    = null
            this.motivo     = "";
            this.sucursal   = null;
            this.urgente    = 0;
            this.vistaPrevias = []
            this.revisionPendiente = null
            this.validarSuccess( response.data.message )
            this.$emit('recargar')
            this.$emit('close')
          }).catch( error =>{
            this.estaProcesando = false;
            this.validarError( error.response.data.message )
          }).finally( () => {
            this.estaProcesando = false;
            this.cargar = false
          })

        }else{
          this.validarErrorDirecto('Favor de llenar todos los datos')
        }

      },

      saveResultado( ){
        this.alumnos_ticket.push({
          ...this.alumno,
          ...this.grupo
        })
      },

      subirFotosServidor( ){
        let formData = new FormData();

        for( const i in this.vistaPrevias ){
          formData.append('file', this.vistaPrevias[i].file )
        }

        return new Promise((resolve,reject)=>{
                // obtener la extensión del archivo
                // Hacemos la petición
          this.$http.post(`tickets.subir.evidencia`, formData ).then(response=>{
            resolve( response )
          }).catch( error =>{
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })
        })
      },

      cargarFotos(){
        if(this.files.length < 1){
          return
        }

        this.files.forEach((element, index) => {
                // creamos una variable tipo FormData
          let formData = new FormData();
                //se crea el objeto y se le agrega como un apendice el archivo 
          formData.append('file', element);
                //mandamos a ocvertir la imagen a base64 pero mandamos el docuemnto, el formdata, el nombre
                if(element.size > 26214400){ //26214400 = 25MB
                  console.log(element.size)
                  this.validarErrorDirecto('El archivo sobrepasa el limite del peso, max 25 MB')
                } else {
                  this.getBase64(element, formData)
                }
              })
      },

      getBase64(file, formData) {
        var me = this
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          console.log(file)
          const tipoArchivo = clasificarArchivoEvidencia(file.name)
          me.vistaPrevias.push({
            url: reader.result, 
            formData: formData, 
            image_name: file.name,
            video : tipoArchivo.video,
            pdf: tipoArchivo.pdf,
            file
          })
        };
      },

      eliminarFoto(value){
        this.vistaPrevias.forEach((element, index)=>{
          if(element.url == value){
            this.vistaPrevias.splice(index,1);
          }
        })
      },

      convertFile(dataurl, filename) {
        var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
      },

      createFile(file) {
        if (file.size > 10000000) {
          alert("please check file size no over 5 MB.");
          this.dragging = false;
          return;
        }

        this.file = file;
        this.archivos = file;
        this.getBase64(this.archivos);
        this.dragging = false;
      },

      async pegar(event) {
        if (event.code == "KeyV") {
          const { type, value } = await Clipboard.read();

                    // Validamos que sea de tipo imagen
          if (type == "image/png") {
                    // Convertimos el base64 en una imagen
            const file = this.convertFile(value, "imagen.png");
            this.createFile(file);
          }
        }
      },


      async getSoporte () {

        this.cargar = true

        this.$http.get('soporte.problemas').then(response=>{

          this.cargar = false

          this.problemas = response.data

          console.log( this.problemas )

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },

      seleccionarRespuesta (id) {
        this.ruta.push(id)
        this.getSoporte()
      },

      reiniciar () {
        this.ruta = []
        this.estado = null
      },

      iniciarChat( id ){
        this.cargar = true

        this.ruta.push( id )

        this.$http.post('soporte.chat', this.ruta ).then(response=>{

          this.cargar = false

          this.estado = response.data

          console.log( this.estado )

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      }

    },
  }

</script>

<style scoped>
.revision-destacada {
  border: 2px solid #fb8c00;
  border-radius: 8px;
  background: #fff8e1;
  padding: 12px;
}
.revision-panel {
  background: #fff8e1;
  border: 1px solid #fb8c00;
  border-radius: 8px;
}
.revision-ejemplo {
  background: #fff;
  border-radius: 6px;
  padding: 8px 10px;
}
</style>